import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { RequestModel } from '../_models/request.model';

const DEFAULT_STATE: ITableState = {
  filter: {},
  paginator: new PaginatorState(),
  sorting: new SortState(),
  searchTerm: '',
  grouping: new GroupingState(),
  entityId: undefined,
  paramsGet: "",
  paramsPost: {}
};

@Injectable({
  providedIn: 'root'
})
export class RequestService extends TableService<RequestModel> implements OnDestroy {
  
  apiUrls = {
    getSolicitudEndoso: `${environment.url}/${environment.apiUrl}/Generico/get_solicitud_Endoso?`,
    getEndosos : `${environment.url}/${environment.apiUrl}/Generico/get_endosos?`,
    getMes : `${environment.url}/${environment.apiUrl}/Generico/get_meses?`,
    getAnyo : `${environment.url}/${environment.apiUrl}/Generico/get_anos?`,
    getStatus : `${environment.url}/${environment.apiUrl}/Generico/get_estatus_endoso?`,

    getAgentes: `${environment.url}/${environment.apiUrl}/Generico/get_agentes?`,
    getAgencias: `${environment.url}/${environment.apiUrl}/Generico/get_agencias?`,
    getCategoriaSolicitud: `${environment.url}/${environment.apiUrl}/Generico/get_categoria_solicitud?`,
    getSucursal: `${environment.url}/${environment.apiUrl}/Generico/get_sucursal?`,
    getEstatusPolizasCortas: `${environment.url}/${environment.apiUrl}/Generico/get_estatus_polizas_cortas?`,
    getLineaNegocioSolicitud: `${environment.url}/${environment.apiUrl}/Generico/get_linea_negocio_solicitud?`,
    getListadoPolizas: `${environment.url}/${environment.apiUrl}/Producer/get_listados_de_polizas_solicitud_corta?`,

    postCrearSolicitudPolizaCorta: `${environment.url}/${environment.apiUrl}/Producer/post_crear_solicitud_poliza_corta?`,
    getBuscarSolicitudPolizaCorta: `${environment.url}/${environment.apiUrl}/Producer/get_buscar_solicitud_poliza_corta?`,
    
    getDocumentosSolicitud: `${environment.url}/${environment.apiUrl}/Generico/get_documentos_solicitud_corta?`,

    getDescargarDocumentoSolicitudCorta: `${environment.url}/${environment.apiUrl}/Producer/get_descargar_documentos_SolicitudCorta?`,
    getDocumentosSolicitudCorta: `${environment.url}/${environment.apiUrl}/Producer/get_documentos_solicitud_corta?`,
    
    postCargarDocumentoSolicitudCorta: `${environment.url}/${environment.apiUrl}/Producer/post_cargar_documento_solicitud_corta?`,
    getGestiones: `${environment.url}/${environment.apiUrl}/Generico/get_gestiones?`,
    getTipoGestionPolizasCortas:`${environment.url}/${environment.apiUrl}/Generico/get_tipo_gestion_polizas_cortas?`,  
    postGestiones: `${environment.url}/${environment.apiUrl}/Generico/post_crear_gestiones?`,
  }

  API_URL = `${environment.url}/${environment.apiUrl}/Producer/get_buscar_solicitud_poliza_corta`;
  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }

   // READ
   find(tableState: ITableState): Observable<TableResponseModel<RequestModel>> {
    return this.http.get<RequestModel[]>(this.apiUrls.getBuscarSolicitudPolizaCorta + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
      map((response: RequestModel[]) => {
        const filteredResult = baseFilter(response, tableState);
        const result: TableResponseModel<RequestModel> = {
          //items: filteredResult.items,
          items: response, // filteredResult.items,
          total: filteredResult.total
        };
        return result;
      })
    );
  }

  //WRITE
  async postCrearSolicitudPolizaCorta(params: any, doc: any = null) {
    var data = new FormData();
    data.append("data", JSON.stringify(params));
   
    return await this.http.post<any>(this.apiUrls.postCrearSolicitudPolizaCorta, data, {headers: this.auth.httpHeaders} ).toPromise();
  }

  //WRITE
  async postProcesarSolicitudPolizaCorta(params: any, doc: any = null) {
    var data = new FormData();
    data.append("data", JSON.stringify(params));
   
    return await this.http.post<any>(this.apiUrls.postCrearSolicitudPolizaCorta, data, {headers: this.auth.httpHeaders} ).toPromise();
  }

  //WRITE
  async postGestiones(params: any, doc: any = null) {
    var data = new FormData();
    data.append("data", JSON.stringify(params));
   
    return await this.http.post<any>(this.apiUrls.postGestiones, data, {headers: this.auth.httpHeaders} ).toPromise();
  }

  // READ
  async getGestiones(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getGestiones + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getTipoGestionPolizasCortas (paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getTipoGestionPolizasCortas + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getListadoPolizas(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getListadoPolizas + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getAgentes(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getAgentes + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getAgencias(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getAgencias + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getCategoriaSolicitud(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getCategoriaSolicitud + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getSucursal(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getSucursal + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getEstatusPolizasCortas(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getEstatusPolizasCortas + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getLineaNegocioSolicitud(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getLineaNegocioSolicitud + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getBuscarSolicitudPolizaCorta(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getBuscarSolicitudPolizaCorta + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }


  // READ
  async getStatus(paramsGet: string = "") {
    return await this.http.get<SubRamo>(this.apiUrls.getStatus + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getMeses(paramsGet: string = "") {
    return  await this.http.get<SubRamo>(this.apiUrls.getMes + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getAnyos(paramsGet: string = "") {
    return await this.http.get<SubRamo>(this.apiUrls.getAnyo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getEndosos(paramsGet: any = "") {
    return await this.http.get<Endoso>(this.apiUrls.getEndosos + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async test(paramsGet: any = "") {
    return await this.http.get(this.apiUrls.getEndosos + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getDocumentosSolicitud(paramsGet: string = "") {
    return await this.http.get<Endoso>(this.apiUrls.getDocumentosSolicitud + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async postCargarDocumentoSolicitudCorta(params: any, doc: any = null) {
    var data = new FormData();
    data.append("IdSolcitud", params.IdSolcitud);
    data.append("IdTipoDocumento", params.IdTipoDocumento);
    data.append("Descripcion", params.Descripcion ? (document.getElementById(params.Descripcion) as HTMLInputElement).value : '');
    data.append(params.file, (document.getElementById(params.file) as HTMLInputElement).files[0]);
    return await this.http.post<any>(this.apiUrls.postCargarDocumentoSolicitudCorta, data, {headers: this.auth.httpHeaders}).toPromise();
}

  async getDocumentosCargados(params: string) {
    return await this.http.get<any>(this.apiUrls.getDocumentosSolicitudCorta + params, {headers: this.auth.httpHeaders}).toPromise();
  }


async getDescargarDocumentoSolicitudCorta(paramsGet: string) {
    //this.auth.httpHeaders.append('Content-Type', 'text/plain; charset=utf-8');
    return await this.http.get(this.apiUrls.getDescargarDocumentoSolicitudCorta + paramsGet, {headers: this.auth.httpHeaders }).toPromise();
  }

  extracData(id, item) {
    var item;

    //FEXME
    item.pipe().subscribe(items => {
      return items.filter(c => {
        if(c.IdSolicitud == id) {
          return (item = c);
        }
      });
    });
        
    return item;
  }

  isUplodadedDocument(id, item) {
    var item;

    //FEXME
    item.pipe().subscribe(items => {
      
      return items.filter(c => {
        if(c.IdTipoDocumento == id) {
          return true;
        }
        return false;
      });
    });
        
    return item;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}